import React, {Component} from 'react'
import {Link} from 'react-router-dom'
import {connect} from 'react-redux'
import {setSelectedCountry, getAllowedCountriesSettings} from '../../panel-admin/common/functions/countrySetting'
import {clearDashboard} from '../../actions/pages/dashboard-page'
import '../../css/elements/dropdown-flags.css'

class DropdownFlags extends Component {
  constructor() {
    super()

    this.onHandleClick = this.onHandleClick.bind(this)
  }

  onHandleClick(selectedCountryCode) {
    setSelectedCountry(selectedCountryCode)

    this.props.clearDashboard();

    if (this.props.onChange) {
      this.props.onChange();
    }
  }

  render() {
    let countriesSettings = this.props.countriesSettings;

    return (
      <div className="navbar-dropdown dropdown-flags">
        <div className="dropdown-inner">
          {countriesSettings.map((countrySettings, i) => (
            <div key={i} className="dropdown-item" onClick={() => this.onHandleClick(countrySettings.countryCode)}>
              <Link to="/">
                <span
                  className={`flag flag-icon-background flag-icon flag-icon-${countrySettings.flagCode}`}
                />
                <span className="country-name">{countrySettings.name}</span>
              </Link>
            </div>
          ))}
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  countriesSettings: getAllowedCountriesSettings()
})
const mapDispatchToProps = dispatch => ({
  clearDashboard() { dispatch(clearDashboard()) }
})

export default connect(mapStateToProps, mapDispatchToProps)(DropdownFlags)